import React from 'react'
import { useNavigation } from '@react-navigation/core'
import { useTranslation } from 'react-i18next'
import { TouchableOpacity, Text, StyleSheet } from 'react-native'
import { paths } from '../../../links'
import { PAGE_MODE } from '../utils/pageMode'

export const GoToAppButton = ({ isWeb, mode }) => {
  const { t } = useTranslation('global')
  const navigation = useNavigation() as any

  let windowFeatures
  if (mode && mode === PAGE_MODE.POPUP)
    windowFeatures = 'width=800,height=600,scrollbars=yes,resizable=yes'

  const text = isWeb
    ? t('quickbooks.go-to-app-web')
    : t('quickbooks.go-to-app-mobile')

  return (
    <TouchableOpacity
      style={styles.goToAppView}
      onPress={() => {
        if (mode) {
          window.open(`/`, '_blank', windowFeatures)
        } else {
          navigation.navigate(paths.Home._self)
        }
      }}
      testID={'go-to-app-button-topbar'}
    >
      <Text testID={'go-to-app-topbar-title'} style={styles.goToAppText}>
        {text}
      </Text>
    </TouchableOpacity>
  )
}

export const LogOutButton = ({ onLogOut }) => {
  const { t } = useTranslation('global')

  const text = t('quickbooks.logout')

  return (
    <TouchableOpacity
      style={styles.goToAppView}
      onPress={onLogOut}
      testID={'log-out-button-topbar'}
    >
      <Text testID={'log-out-topbar-title'} style={styles.goToAppText}>
        {text}
      </Text>
    </TouchableOpacity>
  )
}

export const LoginButton = ({ isWeb, onPress }) => {
  const { t } = useTranslation('global')

  return (
    <TouchableOpacity
      style={[
        styles.loginView,
        isWeb ? styles.loginWebView : styles.loginMobileView,
      ]}
      onPress={onPress}
      testID={'login-button-toolbar'}
    >
      <Text
        style={[
          styles.loginText,
          isWeb ? styles.loginTextWeb : styles.loginTextMobile,
        ]}
      >
        {t('quickbooks.login')}
      </Text>
    </TouchableOpacity>
  )
}
const styles = StyleSheet.create({
  loginView: {
    borderRadius: 8,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center',
  },

  goToAppView: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 44,
    borderRadius: 8,
    backgroundColor: '#EDF1F7',
    paddingHorizontal: 16,
    maxWidth: 172,
  },

  loginMobileView: {
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  loginWebView: {
    backgroundColor: '#00A0F3',
    paddingHorizontal: 24,
    paddingVertical: 16,
    width: 100,
  },
  goToAppText: {
    fontWeight: '700',
    fontFamily: 'Inter',
    fontSize: 14,
    lineHeight: 24,
    textAlign: 'center',
    color: '#335C75',
  },
  loginText: {
    fontFamily: 'Inter',
    fontWeight: '700',
    lineHeight: 24,
    textAlign: 'center',
  },
  loginTextMobile: { color: '#00A0F3', fontSize: 16 },
  loginTextWeb: {
    fontSize: 14,
    color: '#FFFFFF',
  },
})
